/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BigchangeNoteTypesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get all bigchange note types.
     * :param request: Django request
     * :return: HTTP Response with the list of note types
     * @returns any No response body
     * @throws ApiError
     */
    public bigchangeNoteTypesRetrieve(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/bigchange-note-types/',
        });
    }

}
